var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.28906 6.23034V9.73034H4.6224L7.53906 12.647V3.31367L4.6224 6.23034H2.28906ZM10.1641 7.98034C10.1639 7.49157 10.0274 7.01255 9.76971 6.59722C9.51206 6.18188 9.14356 5.84673 8.70573 5.6295V10.3253C9.56906 9.8995 10.1641 9.01284 10.1641 7.98034ZM8.70573 2.8645V4.06617C10.3916 4.56784 11.6224 6.13117 11.6224 7.98034C11.6224 9.8295 10.3916 11.3928 8.70573 11.8945V13.0962C11.0449 12.5653 12.7891 10.477 12.7891 7.98034C12.7891 5.48367 11.0449 3.39534 8.70573 2.8645Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudio);
export default __webpack_public_path__ + "static/media/audio.31e8376026c1516d6200f90c2f037aa1.svg";
export { ForwardRef as ReactComponent };